document.addEventListener('DOMContentLoaded', () => {
  // Announcement close button
  const announcementCloseButton = document.querySelector('.utility-bar--close-button');

  announcementCloseButton.addEventListener('click', () => {
    announcementCloseButton.closest('.utility-bar').style.display = 'none';
  });

  // // Search cart icon
  // const searchCartIcon = document.querySelector('.search_cart_icon');
  // const cartIcon = document.querySelector('#cart-icon-bubble');
  // const body = document.querySelector('body');

  // searchCartIcon.addEventListener('click', () => {
  //   cartIcon.click();
  //   body.classList.add('overflow-hidden');
  // });

  if (document.body.classList.contains('template-page.faqs')) {
    const faqFilter = document.getElementById('FaqSearch');
    const accordions = document.querySelectorAll('.faq__accordions .accordion__wrapper');
    const accordionWrappers = document.querySelectorAll('.faq__section');
    const noResults = document.querySelector('.faq__search-no-results');

    faqFilter.addEventListener("input", () => {
      let value = faqFilter.value.toLowerCase();

      accordions.forEach(function(accordion) {
        accordion.classList.toggle('hidden-block', accordion.textContent.toLowerCase().indexOf(value) == -1);
      });

      accordionWrappers.forEach((wrapper) => {
        const innerAccordions = wrapper.querySelectorAll('.accordion__wrapper');

        [...innerAccordions].some(el => !el.classList.contains('hidden-block'))
          ? wrapper.closest('.section').style.display = 'block'
          : wrapper.closest('.section').style.display = 'none';
      });

      [...accordions].every(el => el.classList.contains('hidden-block'))
        ? noResults.classList.remove('hidden-block')
        : noResults.classList.add('hidden-block');
    });
  }
});

if (!customElements.get('upsell-item')) {
  class UpsellItem extends HTMLElement {
    constructor () {
      super();

      this.select = this.querySelector('.upsell-variant-id-target');
      this.upsellImg = this.querySelector('.upsell__img img');
      this.price = this.querySelector('.upsell_price');
      this.comparePrice = this.querySelector('.upsell_compare_price');
      this.checkbox = this.querySelector('.upsell__variant-checkbox input[type=checkbox]');
      this.quantityInput = this.querySelector('.upsell_quantity_input');
      this.quantityInput?.addEventListener('change', () => {
        if (this.quantityInput.getAttribute('data-init-amount')) {
          this.checkbox.setAttribute('data-quantity', this.quantityInput.value - parseInt(this.quantityInput.getAttribute('data-init-amount')));
        } else {
          this.checkbox.setAttribute('data-quantity', this.quantityInput.value);
        }
      })


      if(this.select) {
        this.select.addEventListener('change', () => {
          if(this.querySelector('.product-variant-id')) {
            this.querySelector('.product-variant-id').value = this.select.value;
          }

          // this.inputId.dispatchEvent(new Event('change'));

          console.log('select change', this.select.value);

          const selectedOption = this.select.options[this.select.selectedIndex];

          if(selectedOption.getAttribute('data-featuredImage')) {
            this.upsellImg.srcset = selectedOption.getAttribute('data-featuredImage');
          }

          if(selectedOption.getAttribute('data-price')) {
            this.price.innerText = selectedOption.getAttribute('data-price');
          }

          if(selectedOption.getAttribute('data-comparePrice')) {
            this.comparePrice.innerText = selectedOption.getAttribute('data-comparePrice');
          }
        })
      }
    }
  }

  customElements.define('upsell-item', UpsellItem);
}




if (!customElements.get('upsells-modal')) {
  class UpsellModal extends HTMLElement {
    constructor () {
      super();
    }

    connectedCallback() {
      const items_checkboxes = this.querySelectorAll('.upsell_main_content input.product-variant-id');
      console.warn('items_checkboxes', items_checkboxes);

      if(items_checkboxes.length) {
        const cartTextElement = this.querySelector('.upsell_modal_submit_text');

        console.warn('cartTextElement', cartTextElement);

        items_checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            console.warn('change event triggered', checkbox.dataset.quantity);
            const checkedCount = this.querySelectorAll('.upsell_main_content input.product-variant-id:checked').length;

            // if (checkedCount === 0) {
              cartTextElement.textContent = window.upsellStrings.no_products_added;
            // } else if (checkedCount === 1) {
            //   cartTextElement.textContent = window.upsellStrings.one_product_added;
            // } else {
            //   cartTextElement.textContent = window.upsellStrings.multiple_products_added.replace('[count]', checkedCount);
            // }
          });
        });
      }
    }
  }
  customElements.define('upsells-modal', UpsellModal);
}

if (!customElements.get('mobile-option-selector')) {
  class MobileOptionSelector extends HTMLElement {
    constructor () {
      super();
    }

    close() {
      this.classList.remove('show');
      document.querySelector('#mobile-option-selector-dialog').close();
    }

    connectedCallback() {
      this.querySelector('.close-icon').addEventListener('click', () => {
        this.close();
      });

      window.addEventListener('click', (e) => {
        if (window.innerWidth > 768) return ;
        if (e.target.classList.contains('mobile-option-selector-select')) {
          this.currentSelect = e.target.querySelector('select');
          e.preventDefault();
          e.stopPropagation();
          this.classList.add('show');
          document.querySelector('#mobile-option-selector-dialog').showModal();

          this.querySelector('.mobile-option-selector__title-text').innerHTML = this.currentSelect.getAttribute('data-label');

          this.querySelectorAll('.mobile-option-selector__options .mobile-option-selector__option').forEach(option => option.remove());
          this.currentSelect.querySelectorAll('option').forEach((option) => {
            let optionNode = this.querySelector('.mobile-option-selector__option_template label').cloneNode(true);
            optionNode.setAttribute('for', 'mobile_selector_' + option.value);
            optionNode.querySelector('.mobile-option-selector__option-title-icon').remove();
            optionNode.querySelector('.mobile-option-selector__option-title-text').textContent = option.textContent;
            optionNode.querySelector('.mobile-option-selector__option-title-radio input').value = option.value;
            optionNode.querySelector('.mobile-option-selector__option-title-radio input').id = 'mobile_selector_' + option.value;
            if (this.currentSelect.value === option.value) {
              optionNode.querySelector('.mobile-option-selector__option-title-radio input').checked = true;
            }
            optionNode.querySelector('.mobile-option-selector__option-title-radio input').addEventListener('change', (e) => {
              this.currentSelect.value = e.target.value;
              this.currentSelect.dispatchEvent(new Event('change'));
              this.close();
            });
            this.querySelector('.mobile-option-selector__options').appendChild(optionNode);
          });
        }
      });
    }
  }
  customElements.define('mobile-option-selector', MobileOptionSelector);
}


if (!customElements.get('multi-select-variant-selector')) {
  class MultiSelectVariantSelector extends HTMLElement {
    constructor () {
      super();
    }

    updateValue() {
      let selectedValue = [];
      this.variantsConfig.options.forEach((option, index) => {
        selectedValue.push(this.querySelectorAll('select[data-option-index="' + index + '"] option:checked')[0].value);
      })
      let variant = this.variantsConfig.variants.find((variant) => {
        return variant.options.join(',') === selectedValue.join(',');
      });
      if (this.parentNode.querySelector('.upsell-variant-id-target')) {
        this.parentNode.querySelector('.upsell-variant-id-target').value = variant.id;
        this.parentNode.querySelector('.upsell-variant-id-target').dispatchEvent(new CustomEvent('change'));
      }
    }

    updateFiltering(selectNode) {
      let selectedValue = selectNode.value;
      let selectedIndex = selectNode.getAttribute('data-option-index');

      let availableVariantsForFilter =  this.availableVariants.filter(variant => {
        return variant.options[selectedIndex] === selectedValue
      });

      this.variantsConfig.options.forEach((option, index) => {
        if (index == selectedIndex) return ;

        let selectForOption = this.querySelector('select[data-option-index="' + index + '"]');
        let currentSelectValue = selectForOption.value;

        let availableValuesForOption = availableVariantsForFilter.map(variant => {
          return variant.options[index];
        }).filter((value, index, self) => self.indexOf(value) === index);

        selectForOption.querySelectorAll('option').forEach(item => item.remove());

        for(let index in availableValuesForOption) {
          let optionNode = document.createElement('option');
          optionNode.value = availableValuesForOption[index];
          optionNode.textContent = availableValuesForOption[index];
          if (optionNode.value == availableValuesForOption[index] || index == 0) {
            optionNode.selected = true;
          }
          selectForOption.appendChild(optionNode);
        }
      });

      this.updateValue();
    }

    connectedCallback() {
      console.log(this.getAttribute('data-variants-config'));
      this.variantsConfig = JSON.parse(this.getAttribute('data-variants-config'));
      this.variantsExcluded = this.getAttribute('data-excluded-variants').split(',');

      this.availableVariants = this.variantsConfig.variants.filter((variant) => {
        return variant.available && !this.variantsExcluded.includes(variant.id);
      })

      this.querySelector('select[data-option-index="0"]').querySelectorAll('option').forEach((option) => {
        let optionValue = option.value;
        let variantFound = false;
        this.variantsConfig.variants.forEach((variant) => {
            if(variant.options[0] == optionValue) {
              variantFound = true;
            }
        })
        if (variantFound === false) {
          option.remove();
        }
      })

      this.updateFiltering(this.querySelector('select[data-option-index="0"]'));

      this.querySelectorAll('select[data-option-index]').forEach(select => {
        select.addEventListener('change', (e) => {
          this.updateFiltering(e.target);
        });
      })
    }
  }
  customElements.define('multi-select-variant-selector', MultiSelectVariantSelector);
}

